import disclosureNav from '../../../public/libraries/disclosureNav/js/disclosureNav.js';

class BuxSidebar {

    private disclosureNavInstance: disclosureNav | undefined = undefined;
    private options = {
        ariaLabel: "Sidebar Navigation",
        orientation: "vertical",
        useHover: false,
        useResponsiveMenu: false,
        activeClass: "bux-sidebar-nav__link--active",
        expandToActive: true,
        expandActiveSubmenu: false,
    };

    constructor(private readonly root: HTMLElement) {
        this.configureExpandSetting();
        this.init();
    }

    private configureExpandSetting(): void {
        const expandTrigger = document.querySelector("[expand-active-submenu]");

        if (expandTrigger) {
            const value = expandTrigger.getAttribute('expand-active-submenu');
            this.options.expandActiveSubmenu = (value === 'true');
        }
    }

    private init(): void {
        const id = this.root.getAttribute("id");

        this.disclosureNavInstance = id ? new disclosureNav(`#${id}`, this.options) : new disclosureNav("#sidebar-nav", this.options);
    }

}

const sidebarRoot = document.querySelector(".bux-sidebar-nav");
if (sidebarRoot instanceof HTMLElement) {
    new BuxSidebar(sidebarRoot);
}

export const init = () => {
    if (document.querySelector(".bux-sidebar-nav")) {
        const sidebarRoot = document.querySelector(".bux-sidebar-nav");
        if (sidebarRoot instanceof HTMLElement) {
            new BuxSidebar(sidebarRoot);
        }
    }
}

if (document.readyState === 'loading') {
    document.addEventListener("DOMContentLoaded", init);
} else {
    init();
}
